export default __webpack_public_path__ + "static/media/phantom-text.19ed38d4.svg";